import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from '../courses/IELTSCourse';
import { complexSentencesData, getDataForDifficulty } from '../courses/data/grammar/complexSentences';

export default function ComplexSentencesTips() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : complexSentencesData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
